module.exports = __webpack_public_path__ + "img/smart-goals.700c55e.jpg";